<script>
    import {createEventDispatcher} from "svelte"
    import { api} from "../../store"

    let  api_url
    api.subscribe(value => (api_url = value))

    export let action
    export let id
    export let field

    let fileInput
    let theFile
    let dispatch = createEventDispatcher()

    $: theFile && theFile.length == 1? updateImage():null;
    function updateImage() {
        console.log(theFile);
      
        let sendData = new FormData()
        let loginDatum = JSON.parse(localStorage.getItem('loginData'))

        sendData.append(field, theFile[0] )
        sendData.append(action,  "true")
        sendData.append("id",  id)
        sendData.append('master', loginDatum.email)
        fetch(`${api_url}matrimonial.php`, {
            method: "POST",
            body:sendData
        })
        .then(res => res.json())
        .then(res => {
        console.log(res.data);
        })
        .finally(()=>{
            dispatch("updated")
        })
    }
</script>

<input style="display: none;" bind:this={fileInput} bind:files={theFile} type="file"/>
<button on:click={()=>{
    fileInput.click();
   
    
}} class="btn btn-success mt-1">Update {field}</button>